import { render, staticRenderFns } from "./ROAChart.vue?vue&type=template&id=230bd2f7&"
import script from "./ROAChart.vue?vue&type=script&lang=js&"
export * from "./ROAChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports